export default "__VITE_ASSET__661f89e5__"